var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('flat-pickr',{staticClass:"form-control custom-date-style",attrs:{"config":_vm.config,"name":"expiry_date[]"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }